import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { userExportColumns } from '../../config/exportColumns/userExportColumns'
import { appGetAllUser } from '../../store/user'

function User() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [activeFilters, setActiveFilters] = useState({})
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Users</div>

					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllUser({ ...params, loading: false }))}
							filters={activeFilters}
							columns={userExportColumns}
							fileName="Users"
							sheetName="User List"
							buttonText="Export Users"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default User
